export default {
explore_by: "esplora per",
explore_by_concepts: "idee",
explore_by_families: "famiglie olfattive",
language: "lingua",
legal: "note legali",
find_any_fragrance: "trova qualsiasi fragranza nel mondo.",
title_by_concepts: "esplora per idee",
desc_by_concepts: "trova la tua fragranza pensando al tuo colore o luogo preferito",
title_by_families: "esplora per famiglie",
desc_by_families: "trova la tua fragranza pensando a ...",
expert_reviewed: "revisionato da esperti",
ingredients: "ingredienti",
description: "descrizione",
perfumist: "profumiere",
concepts: "concetti",
olfactive_family: "famiglia olfattiva",
main_family: "famiglia",
sub_family: "sottofamiglia",
me_family: "Fragranze del mondo",
filter_by_family: "famiglie",
filter_by_brand: "marchi",
filter_by_gender: "genere",
for_him: "per lui",
for_her: "per lei",
unisex: "unisex",
all: "tutti",
all_female: "tutti",
concepts_list: "lista dei concetti",
no_results_for_this_combination: "nessun profumo per questa combinazione.",
select_at_least_one_concept: "seleziona almeno un concetto",
view_perfumes: "visualizza profumi",
back: "torna indietro",
close: "chiudi",
filters: "filtri",
selected_concepts: "concetti selezionati:",
selected_families: "famiglie selezionate:",
find_concept: "trova concetti...",
smell_of: "odore di",
touch_of: "con un tocco di",
loading_perfumes: "caricamento profumi",
loading_concepts: "caricamento concetti",
apply: "applica",
search: "cerca",
clear_all: "cancella tutto",
iconic_fragrances: "fragranze iconiche di questa famiglia",
is_there_anybody_here: "sei ancora qui?",
continue_previous_session: "sì! continuiamo",
reset_session: "riavvia l'esperienza",
ingredient_type: "tipo",
ingredient_parts: "parte/i utilizzata/e",
ingredient_extraction: "metodo di estrazione",
ingredient_first: "profumo iconico",
history: "storia",
effect: "produzione ed effetto",
origin: "origine",
iconic_fragrance: "fragranza iconica",
production: "produzione",
loyalty_become_a_member: "Unisciti al club",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"
}